module.exports = __webpack_public_path__ + "img/birthday_v2.172c613.png";